import { useEffect, useState } from "react";
import { ReactComponent as ArrowRight } from "../../../assets/images/icon/arrow-right.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { deepLinkBridgeElseNewTab, isLogin } from "../../../utils";
import { getNotificationListByMethodStatusAndCreatedDateBetween, getNotificationUserAlarmBoxList, removeUser, requestNotificationReceiptOk, setUrl } from "../../../service";
import NotificationSkeleton from "../../../components/skeleton/notification/notificationSkeleton";
import { TopBar } from "../../../widgets";
import { DividerThin, NotificationAllCard } from "../../../shared";
import dayjs from "dayjs";

const Notification = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [notificationList, setNotificationList] = useState<Array<INotification>>();
    const [isInitLoading, setIsIntLoading] = useState<boolean>(true);

    useEffect(() => {
        if (!isLogin()) {
            setIsIntLoading(false);
            setUrl(location.pathname);
            return;
        }
        requestNoticePopup()
            .finally(() => { setIsIntLoading(false) });
    }, [])
    const getNotificationListByMethodStatusApi = async () => {
        await getNotificationListByMethodStatusAndCreatedDateBetween(undefined, dayjs().add(-30, 'd').format("YYYY-MM-DDTHH:mm:ss"), dayjs().format("YYYY-MM-DDTHH:mm:ss"))
            .then((resNotificationList) => {
                const filteredNotification = resNotificationList.data.filter((resNotificaion) => resNotificaion.notificationStatus === "ALARM")
                getNotificationUserAlarmBoxList(dayjs().add(-30, 'd').format("YYYY-MM-DDTHH:mm:ss"), dayjs().format("YYYY-MM-DDTHH:mm:ss"))
                    .then((res) => { setNotificationList(() => (([...filteredNotification, ...res.data.map((e) => ({ id: e.notificationDetailId, title: e.title, content: e.content, notificationMethodStatus: "", notificationStatus: "", notificationTemplateStatus: "", deepLinkUrlPath: "", createdDate: e.notificationAt, isNotificationV2: true, deepLinkUrl: e.deepLinkUrl, isReceipt: e.isReceipt }))].sort((a, b) => dayjs(b.createdDate).diff(dayjs(a.createdDate)))))) })
                    .catch((error) => { console.error("Error: ", error) })
            })
            .catch((error) => {
                removeUser()
                console.error("Error: ", error)
            })

    }
    const requestNoticePopup = async () => {
        await getNotificationListByMethodStatusApi()
    }

    const clickNavigationDetailPageBydeepLinkUrl = (deepLinkUrl?: string) => {
        if (!deepLinkUrl) return;
        if (process.env.REACT_APP_DOMAIN && deepLinkUrl.startsWith(process.env.REACT_APP_DOMAIN)) {
            navigate(deepLinkUrl.split(process.env.REACT_APP_DOMAIN)[1])
        } else {
            deepLinkBridgeElseNewTab(deepLinkUrl)
            getNotificationListByMethodStatusApi()
        }
    }
    const notificationOnClick = (notification: INotification) => {
        notification.isNotificationV2
            ? requestNotificationReceiptOk(notification.id.toString()).then(() => { clickNavigationDetailPageBydeepLinkUrl(notification.deepLinkUrl) })
            : notification.deepLinkUrlPath && navigate(notification.deepLinkUrlPath);
    }

    return <>
        {isInitLoading && <NotificationSkeleton />}
        <TopBar rightIcon={false} title="알림" />
        {!isLogin()
            ? <div style={{ height: '182px', textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 'var(--space20)' }}>
                <div>로그인 후 이용해 주세요.
                    <div style={{ fontSize: '13px', margin: '10px' }}>
                        <Link to={'/login'} style={{ color: '#777', textDecoration: 'none' }}>로그인 / 회원가입 하러 가기 <ArrowRight width={12} stroke="#000000" /></Link></div>
                </div>
            </div>
            : notificationList &&
            <div style={{ padding: "24px var(--space20)" }}>
                {notificationList.length <= 0
                    ? <div className="body/b2 secondary/s500" style={{ marginBlock: '50%', textAlign: "center" }}>아직 받은 알림이 없습니다<br />최대 1달 전까지의 알림을 보여드립니다</div >
                    : <>
                        {notificationList.map((notification) => <NotificationAllCard key={notification.id} notification={notification} onClick={() => { notificationOnClick(notification) }} />)}
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingInline: 'var(--space20)', marginTop: '30px', gap: '8px' }}>
                            <DividerThin />
                            <div className="body/b1 secondary/s300" style={{ whiteSpace: 'nowrap' }}>
                                최대 1달 전까지의 알림을 보여드립니다
                            </div>
                            <DividerThin />
                        </div>
                    </>}
            </div>}
    </>

}
export { Notification }